import React from 'react';
import dynamic, { DynamicOptions } from 'next/dynamic';
import { ErrorBoundary } from '../ErrorBoundary';

type LazyImport<T> = () => Promise<{ default: T }>;

export const lazyComponent = <T extends React.ComponentType<any>>(
  lazyImport: LazyImport<T>,
  { preload, ssr = false, loading }: { preload?: boolean; ssr?: boolean; loading?: DynamicOptions['loading'] } = {},
) => {
  if (preload) {
    lazyImport();
  }

  const DynamicComponent = dynamic<T>(lazyImport, { ssr, loading }) as T;

  return ((props: React.ComponentProps<T>) => (
    <ErrorBoundary>
      <DynamicComponent {...props} />
    </ErrorBoundary>
  )) as T;
};
